import { Badge } from '@mui/material';
import { Button} from 'antd';

const AntButton = ({ type, text, size, color, dot, onClick,shape,icon ,loading,disabled}) => {
  return (
    dot ? (
      <Badge
        color="primary"
        shape={shape}
        icon={icon}
        variant="dot"
        style={{ width: '100%', color: 'blue' }}
        anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
      >
        <Button
          type={type}
          shape={shape}
          disabled={disabled}
          icon={icon}
          onClick={onClick}
          size={size}
          loading={loading}
          style={{ backgroundColor: color }}
          block={true}
        >
          {text}
        </Button>
      </Badge>
    ) : (
      <Button
        type={type}
        shape={shape}
        icon={icon}
        onClick={onClick}
        disabled={disabled}
        loading={loading}
        size={size}
        style={{ backgroundColor: color }}
        block={true}
      >
        {text}
      </Button>
    )
  );
};

export default AntButton;
